import Vue from 'vue'
// axios
import axios from 'axios';
// import '@/libs/sweet-alerts'
import store from '../store/app'

import VueSweetalert2 from 'vue-sweetalert2';

import handleUnauthorized from '@/auth/handleUnauthorized'
import { getAccessToken } from '@/auth/utils'
import 'sweetalert2/dist/sweetalert2.min.css';
// Initialize a timer variable
Vue.use(VueSweetalert2);


const axiosIns = axios.create({
    headers: { "Content-Type": "application/json" },
})

axiosIns.interceptors.request.use(config => {
    const token = getAccessToken()
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
    }
    // Axios 0.21 keeps default json Content-Type on common/post headers — breaks FormData uploads.
    if (config.data instanceof FormData && config.headers) {
        delete config.headers['Content-Type']
        if (config.headers.common) delete config.headers.common['Content-Type']
        if (config.headers.post) delete config.headers.post['Content-Type']
    }
    return config
})
// axiosIns.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
// axiosIns.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
// Add a request interceptor
// axiosIns.interceptors.request.use(
//   config => {
//     // Modify the request config if needed
//     return config
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )
// Add a response interceptor
axiosIns.interceptors.response.use(
    response => {

        // setTimer()
        // Return response if successful
        return response
    },
    error => {
        // Handle errors here
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status === 401 && !error.config?.skipAuthRedirect) {
                handleUnauthorized()
            }

            if (error.response.status == 403) {
                console.error(error.name, ':', error.response.data.message)
            }
            // console.log('Response Error1:', error.response.status, error.response.data)
        } else if (error.request) {
            // The request was made but no response was received
            // console.log('Request Error2:', error.request)
        } else {
            // Something happened in setting up the request that triggered an Error
            // console.log('General Error3:', error.message)
        }
        return Promise.reject(error)
    }
)

Vue.prototype.$http = axiosIns

export default axiosIns
